/**
 *  AlltId - [All]er [T]raversable [Id]entification - Wrapper
 *  AlltId wrapper Library get the id.min.js file from s3 bucket 
 *  and append to head of the page from where it is triggered.
 *
 * (c) Aller Media
 *
 * Version 1.0
 */
export default class AlltIdAuthorizer {
    constructor(options = {}) {
        if (Object.keys(options).length > 0) {
            this.config = {
                jwt: {},
                bringer: options.bringer || "code",
                terminator: options.terminator || "asend",
                env: options.env || "prod",
                home: options.home || process.env.ALLTID_URL,
                token_verifier_url: options.token_verifier_url || "/aller-verification/verify?",
                brand: options.brand || "",
                events: {
                    loggedIn: options.loggedInEvent || {},
                    notLoggedIn: options.notLoggedInEvent || {},
                }
            };
            this.appendScript();
        }
    }
    appendScript() {
        if (!document.getElementById("alltIdjs")) {
            var header = document.head || document.getElementsByTagName("head")[0];
            var script = document.createElement("script");  // create a script DOM node
            script.type = 'text/javascript';
            script.src = `${process.env.ALLTID_IDJS}/id.min.js`;
            script.id = "alltIdjs";
            header.appendChild(script);
            script.addEventListener('load', () => {
                this.init();
            });
        }
    }
    init() {
        window.alltId.config = this.config;
        window.alltId ? window.alltId.run(this.config.brand) : '';
    }
    logout(url) {
        document.location.href = window.alltId.getBrandLogoutURL(url);
    }
}
